import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Time/Time.Controller.ts
export class TimeAPI {
  static async getTime() {
    return APIService.Server.get<Date>(`/time`);
  }
}
